(function () {
  var roots = document.querySelectorAll("[data-float-nav]");
  if (!roots.length) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function headerOffset() {
    var nav = document.getElementById("nav-fixed-top");
    return nav ? nav.offsetHeight + 8 : 8;
  }

  function parseProduct(root) {
    var node = root.querySelector("[data-float-product]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function findVariant(product, selected) {
    if (!product || !product.variants) return null;
    return (
      product.variants.find(function (variant) {
        return (
          (!selected[0] || variant.option1 === selected[0]) &&
          (!selected[1] || variant.option2 === selected[1]) &&
          (!selected[2] || variant.option3 === selected[2])
        );
      }) || null
    );
  }

  function selectedFromForm(form) {
    var selected = [null, null, null];
    Array.prototype.forEach.call(form.querySelectorAll("[data-option-index]"), function (group) {
      var index = parseInt(group.getAttribute("data-option-index"), 10);
      if (group.tagName === "SELECT") {
        selected[index] = group.value;
        return;
      }
      var current = group.querySelector('[aria-pressed="true"]');
      selected[index] = current ? current.getAttribute("data-value") : null;
    });
    return selected;
  }

  function variantForValues(product, selected) {
    return findVariant(product, selected);
  }

  function valuesWith(selected, index, value) {
    var next = selected.slice();
    next[index] = value;
    return next;
  }

  function addToCart(variantId, quantity) {
    var base = (window.routes && window.routes.cartAddUrl) || "/cart/add";
    document.documentElement.classList.remove("is-page-loading");
    return fetch(base + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(function (response) {
        document.documentElement.classList.remove("is-page-loading");
        return response.json().then(function (payload) {
          if (!response.ok) throw payload;
          return payload;
        });
      })
      .then(function (payload) {
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: { variant: { id: variantId }, quantity: quantity || 1, cartData: payload },
          })
        );
        return payload;
      });
  }

  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return false;
    var top = window.scrollY + target.getBoundingClientRect().top - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? "auto" : "smooth" });
    return true;
  }

  function revealNav(root) {
    root.classList.remove("is-waiting");
    root.classList.add("is-ready");
    root.removeAttribute("aria-hidden");
  }

  function bindIntro(root) {
    if (root.getAttribute("data-wait-intro") !== "true") {
      revealNav(root);
      return;
    }
    var origin = document.querySelector(".tr20-origin");
    if (!origin || origin.classList.contains("is-intro-done")) {
      revealNav(root);
      return;
    }
    document.addEventListener(
      "tr20:intro-done",
      function () {
        revealNav(root);
      },
      { once: true }
    );
    window.setTimeout(function () {
      if (root.classList.contains("is-waiting")) revealNav(root);
    }, 9000);
  }

  function bindNav(root) {
    bindIntro(root);
    var host = root.closest(".landing-float-nav-section") || root.parentElement || document;
    var product = parseProduct(root);
    var modal = host.querySelector("[data-float-modal]");
    var sizechart = host.querySelector("[data-float-sizechart]");
    var form = host.querySelector("[data-float-form]");
    var priceNode = host.querySelector("[data-float-price]");
    var errorNode = host.querySelector("[data-float-error]");
    var preorderNode = host.querySelector("[data-float-preorder]");
    var submit = host.querySelector("[data-float-submit]");
    var cta = root.querySelector("[data-float-cta]");
    var moneyFormat = root.getAttribute("data-money-format") || "";
    var forceModal = root.getAttribute("data-force-modal") === "true";
    var links = Array.prototype.slice.call(root.querySelectorAll("[data-float-anchor]"));
    var closeTimer = 0;
    var openRaf = 0;
    var defaultSubmit = (submit && (submit.getAttribute("data-label-add") || submit.textContent)) || "";
    var addingLabel = (submit && submit.getAttribute("data-label-adding")) || "Adding…";
    var backdrop = host.querySelector("[data-float-backdrop]");
    var panel = host.querySelector("[data-float-panel]");
    var handle = host.querySelector("[data-float-handle]");
    var lockClass = "landing-float-nav-lock";
    var sheetDrag = { active: false, startY: 0, y: 0 };

    function currentVariant() {
      if (!product) return null;
      if (product.has_only_default_variant) return product.variants[0] || null;
      if (!form) return product.variants[0] || null;
      return findVariant(product, selectedFromForm(form));
    }

    function noticeFor(variant) {
      if (variant && variant.availability_notice) return variant.availability_notice;
      if (product && product.availability_notice) return product.availability_notice;
      return "";
    }

    function syncPreorder(variant) {
      if (!preorderNode) return;
      var notice = noticeFor(variant);
      preorderNode.hidden = !notice;
      preorderNode.innerHTML = notice || "";
    }

    function syncModal() {
      var selected = form ? selectedFromForm(form) : [null, null, null];
      var variant = currentVariant();
      if (priceNode && variant) priceNode.textContent = formatMoney(variant.price, moneyFormat);
      if (submit) {
        submit.disabled = !variant || !variant.available;
        if (submit.getAttribute("data-busy") !== "true") submit.textContent = defaultSubmit;
      }
      syncPreorder(variant);
      if (!form || !product) return;
      Array.prototype.forEach.call(form.querySelectorAll(".landing-float-nav__size"), function (button) {
        var group = button.closest("[data-option-index]");
        var index = group ? parseInt(group.getAttribute("data-option-index"), 10) : 0;
        var probe = variantForValues(product, valuesWith(selected, index, button.getAttribute("data-value")));
        button.classList.toggle("is-unavailable", !(probe && probe.available));
      });
    }

    function showError(message) {
      if (!errorNode) return;
      errorNode.hidden = !message;
      errorNode.textContent = message || "";
    }

    function isModalOpen() {
      return !!(modal && !modal.hidden && modal.classList.contains("is-open"));
    }

    function lockPage() {
      document.documentElement.classList.add(lockClass);
    }

    function unlockPage() {
      document.documentElement.classList.remove(lockClass);
    }

    function cartDrawerOpen() {
      var cart = document.getElementById("sidebar-cart");
      return !!(cart && cart.getAttribute("aria-hidden") === "false");
    }

    function clearSheetY() {
      if (modal) modal.style.removeProperty("--sheet-y");
      if (modal) modal.classList.remove("is-dragging");
      sheetDrag.active = false;
      sheetDrag.y = 0;
    }

    function openModal() {
      if (!modal || cartDrawerOpen()) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = 0;
      }
      if (openRaf) {
        cancelAnimationFrame(openRaf);
        openRaf = 0;
      }
      showError("");
      closeSizechart();
      syncModal();
      clearSheetY();
      modal.hidden = false;
      modal.removeAttribute("hidden");
      modal.removeAttribute("open");
      modal.classList.remove("is-open");
      lockPage();
      if (reducedMotion) {
        modal.classList.add("is-open");
        return;
      }
      void modal.offsetWidth;
      openRaf = requestAnimationFrame(function () {
        openRaf = 0;
        if (!modal || modal.hidden || cartDrawerOpen()) return;
        modal.classList.add("is-open");
      });
    }

    function closeSizechart() {
      if (!sizechart) return;
      sizechart.hidden = true;
    }

    function openSizechart() {
      if (!sizechart) return;
      sizechart.hidden = false;
    }

    function hardCloseModal() {
      closeSizechart();
      if (!modal) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = 0;
      }
      if (openRaf) {
        cancelAnimationFrame(openRaf);
        openRaf = 0;
      }
      modal.classList.remove("is-open");
      modal.hidden = true;
      modal.setAttribute("hidden", "");
      modal.removeAttribute("open");
      clearSheetY();
      unlockPage();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      closeSizechart();
      modal.classList.remove("is-open");
      function hide() {
        hardCloseModal();
      }
      if (reducedMotion) {
        hide();
        return;
      }
      closeTimer = setTimeout(hide, 420);
    }

    function bindSheetDrag() {
      if (!modal || !handle) return;

      function startDrag(clientY) {
        sheetDrag.active = true;
        sheetDrag.startY = clientY;
        sheetDrag.y = 0;
        modal.classList.add("is-dragging");
      }

      function moveDrag(clientY) {
        if (!sheetDrag.active) return;
        sheetDrag.y = Math.max(0, clientY - sheetDrag.startY);
        modal.style.setProperty("--sheet-y", sheetDrag.y + "px");
      }

      function endDrag() {
        if (!sheetDrag.active) return;
        sheetDrag.active = false;
        modal.classList.remove("is-dragging");
        if (sheetDrag.y > 88) {
          closeModal();
          return;
        }
        modal.style.setProperty("--sheet-y", "0px");
      }

      handle.addEventListener(
        "touchstart",
        function (event) {
          if (event.target.closest("[data-float-close]")) return;
          if (!event.touches || !event.touches[0]) return;
          startDrag(event.touches[0].clientY);
        },
        { passive: true }
      );
      handle.addEventListener(
        "touchmove",
        function (event) {
          if (!sheetDrag.active || !event.touches || !event.touches[0]) return;
          moveDrag(event.touches[0].clientY);
        },
        { passive: true }
      );
      handle.addEventListener("touchend", endDrag);
      handle.addEventListener("touchcancel", endDrag);
    }

    bindSheetDrag();

    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("data-float-anchor");
        if (!id) return;
        if (scrollToId(id)) event.preventDefault();
        setActive(id);
      });
    });

    if (cta) {
      cta.addEventListener("click", function () {
        if (!product || !product.available) return;
        if (!forceModal && product.has_only_default_variant && product.variants[0]) {
          addToCart(product.variants[0].id, 1).catch(function (err) {
            window.alert((err && (err.description || err.message)) || "Could not add to cart");
          });
          return;
        }
        openModal();
      });
    }

    if (form) {
      form.addEventListener("click", function (event) {
        var button = event.target.closest(".landing-float-nav__size");
        if (!button || !form.contains(button)) return;
        var group = button.closest("[data-option-index]");
        if (!group) return;
        Array.prototype.forEach.call(group.querySelectorAll(".landing-float-nav__size"), function (item) {
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
        showError("");
        syncModal();
      });
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var variant = currentVariant();
        if (!variant || !variant.available) {
          showError("Sold out");
          return;
        }
        showError("");
        hardCloseModal();
        if (submit) {
          submit.disabled = true;
          submit.setAttribute("data-busy", "true");
          submit.textContent = addingLabel;
        }
        window.requestAnimationFrame(function () {
          addToCart(variant.id, 1)
            .then(function () {
              hardCloseModal();
            })
            .catch(function (err) {
              if (!cartDrawerOpen()) openModal();
              showError((err && (err.description || err.message)) || "Could not add to cart");
            })
            .then(function () {
              if (submit) submit.removeAttribute("data-busy");
              syncModal();
            });
        });
      });
    }

    host.querySelectorAll("[data-float-close]").forEach(function (button) {
      button.addEventListener("click", closeModal);
    });

    host.querySelectorAll("[data-float-sizechart-open]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        openSizechart();
      });
    });

    host.querySelectorAll("[data-float-sizechart-close]").forEach(function (button) {
      button.addEventListener("click", closeSizechart);
    });

    if (backdrop) {
      backdrop.addEventListener("click", function () {
        closeModal();
      });
    }

    if (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal || event.target === backdrop) closeModal();
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" && event.keyCode !== 27) return;
      if (!isModalOpen()) return;
      if (sizechart && !sizechart.hidden) {
        closeSizechart();
        return;
      }
      event.preventDefault();
      closeModal();
    });

    document.addEventListener("product:added", function () {
      document.documentElement.classList.remove("is-page-loading");
      hardCloseModal();
    });

    if (!links.length) return;

    var sections = links
      .map(function (link) {
        var id = link.getAttribute("data-float-anchor");
        return { id: id, link: link, el: id ? document.getElementById(id) : null };
      })
      .filter(function (item) {
        return item.el;
      });

    function setActive(id) {
      links.forEach(function (link) {
        link.classList.toggle("is-active", link.getAttribute("data-float-anchor") === id);
      });
    }

    function updateActive() {
      var marker = window.innerHeight * 0.42;
      var current = sections[0];
      sections.forEach(function (item) {
        if (item.el.getBoundingClientRect().top <= marker) current = item;
      });
      if (current) setActive(current.id);
    }

    window.addEventListener("scroll", updateActive, { passive: true });
    window.addEventListener("resize", updateActive);
    updateActive();
  }

  roots.forEach(bindNav);
})();
